import { render, staticRenderFns } from "./SponsorBonus.vue?vue&type=template&id=8bca4ba0&"
import script from "./SponsorBonus.vue?vue&type=script&lang=js&"
export * from "./SponsorBonus.vue?vue&type=script&lang=js&"
import style0 from "./SponsorBonus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports